import React from "react";
import "./App.css";
import Navbar from "./component/navbar";
import {BrowserRouter as Router,Switch,Route, BrowserRouter} from "react-router-dom";
import Home from "./component/home";
import Service_Page from "./component/page/Services";
import About_Page from "./component/page/About";
import Contact_Page from "./component/page/Contact";
import BRACES_ORTHODONTICS_Page from "./component/page/BRACES_ORTHODONTICS";
import COSMETIC_DENTISTRY_Page from "./component/page/Cosmetic_Dentistry";
import DENTAL_IMPLANT_Page from "./component/page/Dental_Implant";
import ROOT_CANEL from "./component/page/Root_Canel";
import CROWNS_BRIDGES_Page from "./component/page/CROWNS_BRIDGES";
import CHILD_DENTISTRY_Page from "./component/page/CHILD_DENTISTRY";
import Veeners_Page from "./component/page/Veeners";
import TEETH_WHITENING_Page from "./component/page/Teeth_Whitening";
import ORAL_SURGERY_Page from "./component/page/ORAL_SURGERY";
import Explore_Page from "./component/page/explore_Page";
import ScrollToTop from "./component/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <Router>
        <ScrollToTop />
        <Navbar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/service" exact component={Service_Page} />
          <Route path="/about" exact component={About_Page} />
          <Route path="/contact" exact component={Contact_Page} />
          <Route
            path="/service/braces_orthodontics"
            exact component={BRACES_ORTHODONTICS_Page}
          />
          <Route
            path="/service/COSMETIC_DENTISTRY"
            exact component={COSMETIC_DENTISTRY_Page}
          />
          <Route
            path="/service/DENTAL_IMPLANT"
            exact component={DENTAL_IMPLANT_Page}
          />
          <Route path="/service/ROOT_CANEL" exact component={ROOT_CANEL} />
          <Route
            path="/service/crowns_bridges"
            exact
            component={CROWNS_BRIDGES_Page}
          />
          <Route
            path="/service/CHILD_DENTISTRY"
            exact
            component={CHILD_DENTISTRY_Page}
          />
          <Route path="/service/venners" exact component={Veeners_Page} />
          <Route
            path="/service/TEETH_WHITENING"
            exact
            component={TEETH_WHITENING_Page}
          />
          <Route
            path="/service/ORAL_SURGERY"
            exact
            component={ORAL_SURGERY_Page}
          />
          <Route path="/about/explore_us" exact component={Explore_Page} />
        </Switch>
      </Router>
      </BrowserRouter>
  );
}
export default App;
